export declare type ChangeToolSizeEventType = 'INCREASE' | 'DECREASE';
